import React from 'react';
import { NavLink } from 'react-router-dom';
import SiteContentContext from '../../content/SiteContentContext';
import { getTranslations, getByPath } from '../../content/siteContentUtils';

class Navigation extends React.Component {
    static contextType = SiteContentContext;

    componentDidMount() {
        function loadScript(src) {
            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            });
        }

        loadScript('./assets/js/mobilenav.js');
    }

    render() {
        const content = this.context?.content || {};
        const t = getTranslations(content);
        const headerText = t?.header || {};
        const catalogUrl = (getByPath(content, 'media.catalogPdfUrl', '') || '').trim();
        const referencesUrl = (getByPath(content, 'media.referencesPdfUrl', '') || '').trim();

        return (
            <>
                <ul className="nav navbar-nav">
                    <li className="active">
                        <NavLink to="/">Anasayfa</NavLink>
                    </li>
                    <li>
                        <NavLink to="/hakkimizda">{'Hakk\u0131m\u0131zda'}</NavLink>
                    </li>
                    <li>
                        <NavLink to="/daire-giris-kapilari">{'Daire Giri\u015F Kap\u0131lar\u0131'}</NavLink>
                    </li>
                    <li>
                        <NavLink to="/villa-kapi-modelleri">{'Villa Kap\u0131 Modelleri'}</NavLink>
                    </li>
                    <li>
                        <NavLink to="/bina-giris-kapilari">{'Bina Giri\u015F Kap\u0131lar\u0131'}</NavLink>
                    </li>
                    <li>
                        <NavLink to="/ic-kapilar">{'\u0130\u00E7 Kap\u0131lar'}</NavLink>
                    </li>
                    <li>
                        <a
                            href={catalogUrl || '#'}
                            target="_blank"
                            rel="noreferrer"
                            onClick={(event) => {
                                if (!catalogUrl) {
                                    event.preventDefault();
                                }
                            }}
                        >
                            {headerText.catalogLabel || 'Katalog'}
                        </a>
                    </li>
                    <li>
                        <a
                            href={referencesUrl || '#'}
                            target="_blank"
                            rel="noreferrer"
                            onClick={(event) => {
                                if (!referencesUrl) {
                                    event.preventDefault();
                                }
                            }}
                        >
                            {headerText.referencesLabel || 'Referanslarımız'}
                        </a>
                    </li>
                    <li>
                        <NavLink to="/iletisim">{'\u0130leti\u015Fim'}</NavLink>
                    </li>
                </ul>
            </>
        );
    }
}

export default Navigation;
